import { render, staticRenderFns } from "./AddressFormComponent.vue?vue&type=template&id=7f1189f4"
import script from "./AddressFormComponent.vue?vue&type=script&lang=js"
export * from "./AddressFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports